@if (typeProps) {
    <button
        nz-button
        nz-tooltip
        [nzTooltipTitle]="tooltip"
        [nzType]="typeProps.type"
        [nzSize]="buttonSize"
        [nzShape]="typeProps.shape"
        [nzLoading]="loading"
        [disabled]="disabled"
        [attr.slim]="typeProps.slim"
        [nzDanger]="typeProps.danger || pfDanger"
        [nzBlock]="typeProps.width === 'full'"
        [class.has-actions]="!!buttonActions?.length"
        (click)="buttonClickHandler()">
        @if (!!typeProps.icon) {
            <pf-icon
                [size]="buttonSize === 'small' ? 'xs' : 'lg'"
                [iconType]="typeProps.icon"
                [rotate]="typeProps.iconRotate"
                (click)="iconClickHandler($event)"></pf-icon>
        }
        @if (buttonType() !== "icon") {
            <span class="pf-btn-content">
                <ng-content></ng-content>
            </span>
        }
        @if (buttonActions?.length) {
            <div
                class="btn-actions-container"
                nz-dropdown
                nzTrigger="click"
                [(nzVisible)]="showActions"
                [nzDropdownMenu]="submitActions"
                (click)="$event.stopPropagation()">
                <pf-icon class="btn-actions-icon" iconType="expand"></pf-icon>
            </div>
        }
    </button>
}

<nz-dropdown-menu #submitActions="nzDropdownMenu">
    <ul nz-menu>
        @for (action of buttonActions || []; track action) {
            <li nz-menu-item (click)="action.action(actionsContext)">
                <a>
                    @if (action.iconType) {
                        <pf-icon [iconType]="action.iconType"></pf-icon>
                    }
                    {{ action.label }}</a
                >
            </li>
        }
    </ul>
</nz-dropdown-menu>
